
import { computed, defineComponent, reactive } from 'vue';
import { Modal } from 'ant-design-vue';
import Icone from '@/core/components/Icone.vue';
import { IPessoaAnexo } from '@/models/Entidades/Cadastros/Pessoas/IPessoaAnexo';
import ServicoPessoa from '@/servicos/Cadastros/Pessoas/ServicoPessoa';
import { IRetornoArquivo } from '@/core/models/IRetornoArquivo';
import { IArquivo } from '@/models/Entidades/MeuSistema/IArquivo';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { useTelaBase } from '@/core/composables/TelaBase';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';

export default defineComponent({
  name: 'AnexosPessoa',
  props: {
    anexos: {
      type: Array as () => IPessoaAnexo[],
      required: true,
    },
  },
  components: {
    Icone,
  },
  emits: ['update:anexos'],
  setup(props, { emit }) {
    const { apresentarMensagemAlerta } = useTelaBase();
    const state = reactive({
      enviandoArquivos: false,
      excluindoArquivos: false,
    });

    const servicoPessoa = new ServicoPessoa();
    const computedAnexosPessoa = computed({
      get: () => props.anexos,
      set: (valor: IPessoaAnexo[]) => {
        emit('update:anexos', valor);
      },
    });

    async function removerAnexo(codigo:number, codigoArquivo: number) {
      state.excluindoArquivos = true;
      const retornoArquivo = await servicoPessoa.removerAnexo(codigo, codigoArquivo);
      if (retornoArquivo.status === EStatusRetornoRequisicao.Sucesso) {
        const index = computedAnexosPessoa.value.findIndex((c) => c.codigoArquivo === codigoArquivo);
        if (index !== -1) {
          computedAnexosPessoa.value.splice(index, 1);
        }
      } else {
        apresentarMensagemAlerta(retornoArquivo.mensagem);
      }
      state.excluindoArquivos = false;
    }

    async function visualizarAnexo(arquivo:IArquivo) {
      if (!UtilitarioGeral.valorValido(arquivo.link)) {
        const retornoArquivo = await servicoPessoa.gerarLinkAnexo(arquivo);
        if (retornoArquivo.status === EStatusRetornoRequisicao.Sucesso) {
          UtilitarioGeral.downloadArquivo(retornoArquivo.linkArquivo);
        } else {
          apresentarMensagemAlerta(retornoArquivo.mensagem);
        }
      } else {
        UtilitarioGeral.downloadArquivo(arquivo.link);
      }
    }

    function selecionarArquivoUpload() {
      const elemento = document.getElementById('selecionarAnexoPessoa');
      if (elemento !== null) {
        elemento.click();
      }
    }
    function confirmaExclusao(pessoaAnexo: IPessoaAnexo) {
      Modal.confirm({
        title: 'Você deseja remover o anexo:',
        content: `${pessoaAnexo.arquivo.nome} ?`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: () => { removerAnexo(pessoaAnexo.codigo, pessoaAnexo.codigoArquivo); },
      });
    }
    function novoAnexo(retorno: IRetornoArquivo) {
      const pessoaAnexo:IPessoaAnexo = {} as IPessoaAnexo;
      pessoaAnexo.codigo = 0;
      pessoaAnexo.codigoArquivo = retorno.codigoArquivo;
      pessoaAnexo.arquivo = {} as IArquivo;
      pessoaAnexo.arquivo.nome = retorno.arquivo;
      pessoaAnexo.arquivo.link = retorno.linkArquivo;
      pessoaAnexo.arquivo.tamanhoApresentacao = retorno.tamanhoApresentacao;
      computedAnexosPessoa.value.push(pessoaAnexo);
    }
    async function enviarArquivos(event:any) {
      state.enviandoArquivos = true;
      const retornoAnexos = await servicoPessoa.enviarAnexos(event.target.files);
      retornoAnexos.forEach((retorno) => {
        if (retorno.status) {
          novoAnexo(retorno);
        }
      });

      state.enviandoArquivos = false;
    }

    async function drop(event:any) {
      state.enviandoArquivos = true;
      const retornoAnexos = await servicoPessoa.enviarAnexos(event.dataTransfer.files);
      retornoAnexos.forEach((retorno) => {
        if (retorno.status) {
          novoAnexo(retorno);
        }
      });
      state.enviandoArquivos = false;
    }

    return {
      computedAnexosPessoa,
      state,
      confirmaExclusao,
      drop,
      enviarArquivos,
      visualizarAnexo,
      selecionarArquivoUpload,
    };
  },
});
